import getThreadId from '@/lib/threads/getThreadId.js';
import matchesThreadListScope from '@/lib/threads/matchesThreadListScope.js';
import normalizeThreadItems from '@/lib/threads/normalizeThreadItems.js';
import sortThreadsBySidebarTimestamp from '@/lib/threads/sortThreadsBySidebarTimestamp.js';

const replaceThreadsForScope = ({ existingThreads = [], incomingThreads = [], threadListScope } = {}) => {
  const normalizedExistingThreads = normalizeThreadItems({ threads: existingThreads });
  const normalizedIncomingThreads = normalizeThreadItems({ threads: incomingThreads });
  const remainingThreads = normalizedExistingThreads.filter((thread) => {
    return !matchesThreadListScope({
      thread,
      threadListScope
    });
  });
  const seenThreadIds = new Set();
  const mergedThreads = [];

  for (const thread of [...remainingThreads, ...normalizedIncomingThreads]) {
    const threadId = getThreadId(thread);

    if (!threadId || seenThreadIds.has(threadId)) {
      continue;
    }

    seenThreadIds.add(threadId);
    mergedThreads.push(thread);
  }

  return sortThreadsBySidebarTimestamp(mergedThreads);
};

export default replaceThreadsForScope;
